import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
import { Footer } from './Footer';
export function OfferSection() {
  return <section id="oferta" className="py-24 bg-navy-950 relative border-t border-navy-800 overflow-hidden" data-id="element-113">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-114" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-navy-900 border border-gold-500/30 rounded-3xl p-8 md:p-16 shadow-[0_0_50px_rgba(212,168,67,0.1)]" data-id="element-116">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 uppercase" data-id="element-117">
            Asegura Tu Logística <span className="text-gold-400" data-id="element-118">Hoy</span>
          </h2>

          <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-119">
            Asegura tu logística antes de que los precios de los servicios
            básicos en las sedes se disparen de forma irreversible.
          </p>

          <div className="mb-10 flex flex-col items-center gap-3" data-id="element-120">
            <span className="inline-block px-4 py-1.5 bg-pitch-500 text-white text-sm font-bold uppercase tracking-wider rounded-full" data-id="element-121">
              -76% de descuento
            </span>
            <div className="flex items-baseline gap-3 flex-wrap justify-center" data-id="element-122">
              <span className="text-3xl text-slate-500 line-through font-heading" data-id="element-123">
                $27.00
              </span>
              <span className="text-7xl font-bold text-white font-heading tracking-tighter drop-shadow-lg" data-id="element-124">
                $6.39
              </span>
              <span className="text-2xl text-gold-400 font-bold" data-id="element-125">USD</span>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center gap-6" data-id="element-126">
            <CTAButton className="w-full sm:w-auto sm:min-w-[300px]" data-id="element-127" />

            <div className="flex items-center gap-2 text-sm text-slate-400" data-id="element-128">
              <ShieldCheckIcon className="w-4 h-4 text-pitch-500" data-id="element-129" />
              <span data-id="element-130">
                Acceso inmediato en formato PDF compatible con todos tus
                dispositivos.
              </span>
            </div>
          </div>
        </motion.div>
      </div>

      <Footer data-id="element-131" />
    </section>;
}